// extracted by mini-css-extract-plugin
module.exports = {"modalGroup":"styles_modalGroup__McjKH","bold":"styles_bold__3TYlh","loader":"styles_loader__1ZFeP","weightText":"styles_weightText__1tD4o"};